import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { PaletteDocument } from "@/models/PaletteDocument";

const state = {
    pointageEnCours: [],
    listTempsAccueil: [],
    listSupplements: [],
    listTempsAccueilFiltred: [],
    listSupplementsFiltred: [],
    listPointagesPrevi: [],
    paletteEncours: new PaletteDocument({}),
    listSupplementsActifs: [],
    lastAction: {
        name: "NoAction",
        value: "NoValue"
    },
    listSupplementsPrevi: [],
    listPalettePresence: [],
    listPaletteAbsence: [],
    listGroupes: [],
    listRegim: [],
    individusPresents: [],
    individusFiltreesPresents: [],
    vieQuoRegimeAli: []
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}